import React from 'react';
import { IAccount } from '../../../../Layout/Account/Data';
import GuidanceCheckBox from '../../../../Common/UI/CheckBox';

interface IAccountProps {
  account: IAccount;
  handleCheck: (id: string) => void;
}

function Account({ account, handleCheck }: IAccountProps) {
  return (
    <GuidanceCheckBox
      id={account.id}
      checked={account.checked}
      label={`${account.number} - ${account.title}`}
      onClick={() => handleCheck(account.id)}
    />
  );
}

export default Account;
